import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import '../../Styles/Taetigkeitsbericht/taetigkeiten.css';
import TatigTagesImageSliderComponent from "./TatigTagesImageSliderComponent";

function TagesTaetigkeiten(props) {

    const [taetigkeitenData, setTaetigkeitenData] = useState(props.taetigkeitenData);
    const [taetigkeitenImages, setTaetigkeitenImages] = useState(props.taetigkeitenImages);

    useEffect(() => {
        setTaetigkeitenData(props.taetigkeitenData);
        setTaetigkeitenImages(props. taetigkeitenImages);
    }, [props.taetigkeitenImages, props.taetigkeitenData]);




    function getTaetigkeitenIndividual(taetigkeitenImages) {

        return (
            <>
                <Row style={{ 
                    // background:'red'
                 }}>
{/*
                    <Col sm={1}/>
*/}
                    <Col>
                        {taetigkeitenImages?.length ? (
                            <TatigTagesImageSliderComponent
                                images={taetigkeitenImages}
                                width={500}
                                height={400}
                                />) : null}
                    </Col>

                    <Col>
                        {taetigkeitenImages.length !== 0 &&
                            <textarea
                                className="handwai-dark handwai-text-label-normal add-bottom-21-padding"
                                style={{width: "80%",fontSize: "16px"}}
                                disabled={true}
                                rows={7}

                                key={taetigkeitenData}
                                defaultValue={taetigkeitenData}
                            />
                        }
                    </Col>
                </Row>
                <br/>
            </>
        )
    }

    function getTaetigkeiten(taetigkeitenImages) {
        return getTaetigkeitenIndividual(taetigkeitenImages)
    }

    return (
        <>
{/*
            <div className="tatigkeiten-div-scroll">{getTaetigkeiten(taetigkeitenImages)}</div>
*/}
                        <div>{getTaetigkeiten(taetigkeitenImages)}</div>

        </>
    );

}

export default TagesTaetigkeiten;
